/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { IRFerias } from '../../../shared/services/api/rh/Relatorios/RelatoriosService';
import moment from 'moment';


async function RelatorioFerias(dados: IRFerias[], periodo: string){
  
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const TTotalInss = dados.reduce((acc, item) => acc + item.valorinss, 0);

  const rows = dados.map((row) => {
    return [
      {text: row.nome, alignment: 'left',  fontSize: 10},
      {text: row.cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'), alignment: 'left',  fontSize: 10},
      {text: moment(row.datainicial).format('DD/MM/YYYY'),  fontSize: 10, alignment: 'center'},
      {text: moment(row.datafinal).format('DD/MM/YYYY'), fontSize: 10, alignment: 'center'},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(row.valorinss), alignment: 'right',  fontSize: 10},
    ]; 
  });  

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';   
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas'); 
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl =  window.env.REACT_APP_URL_IMGLOG || ''; 
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }

  const documentDefinition : any = {
    pageSize: 'A4',
    pageMargins: [20, 20, 10, 10],
    header: '',
    content: ([
      {   
        table: {
          body: [
            [ 
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],  
                table: {
                  widths: [500],
                  body: [
                    [ 
                      {text: window.env.REACT_APP_URL_EMPRESA, fontSize: 16,  margin: [0, 5, 0, 0], bold: true, color: '#FFFFFF',  alignment: 'center', fillColor: '#00A47B', border: [false, false, false, false]},
                    ],
                    [ 
                      {text: window.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true]},
                    ],
                  ]
                }
              },
              
            ],
            [
              {text: 'Relatório Férias', colSpan: 2, margin: [5, 10, 0, 0], fontSize: 18, bold: true,  alignment: 'center',  border: [false, false, false, false]},
              {}
            ]
          ]
        } 
      },
      {text: 'Periodo: ' + periodo, fontSize: 14},
      {  
        table:{
          widths: [200, 80, 60, 60, 60, 60],
          headerRows: 1,
          body: [
            [
              {text: 'Colaborador',  style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 10},
              {text: 'CPF',  style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 10},
              {text: 'Data Inicial', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 10},
              {text: 'Data Final', style: 'tableHeader',  alignment: 'center', fillColor: '#dddddd', fontSize: 10},
              {text: 'Valor', style: 'tableHeader',  alignment: 'center', fillColor: '#dddddd', fontSize: 10},
            ],
            ...rows, 
            [
              {text: '', border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(TTotalInss), alignment: 'right',  fillColor: '#dddddd', fontSize: 10, bold: true},             
            ]
          ]
        },
      },   
    ]),
      
  };
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.open();
}
export default RelatorioFerias;

